import { memo } from 'react'
import { Environment as EnvironmentImpl } from '@react-three/drei'
export const Environment = memo(() => (
  <EnvironmentImpl preset="city" />
))